import React from "react";
import { URL_SOUNDCLOUD, URL_SOUNDCLOUD_IFRAME } from "../../../constants";

const Records = () => (
  <div>
    <iframe width="100%" height="166" scrolling="no" frameBorder="no"
            src={URL_SOUNDCLOUD_IFRAME}>
    </iframe>
    <p className="center-align">Retrouvez notre playlist complète sur notre SoundCloud :<br/><br/><a
      className="white-text text-lighten-3 waves-effect waves-light btn soundcloud-button" href={URL_SOUNDCLOUD}
      target="_blank" rel="noopener"><i className="material-icons left">cloud</i>Soundcloud</a><br/><br/>
    </p>
  </div>
)

export default Records;



/** WEBPACK FOOTER **
 ** ./src/components/Media/Records/Records.jsx
 **/